import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/style.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from ".././../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import Navigationtitle from "../include/Navigationtitle";
import DataService from ".././../services/tutorial.service";
import { actlistData } from "../../actions/index";
import Demo from "../crop/Demo";
import { auctiondefaultLogo } from "../../constants/Images";
import { getSeason } from "../../Helpers/Helpers";
import $ from "jquery";
import moment from "moment";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";
import { getDatabase, ref, remove,push, onValue, set, update } from "firebase/database";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import ImageCropper1 from "../cropper/ImageCropper";
import ImageCropper2 from '../utils/Demo';
// import moment from 'moment'
function Editauction(match) {
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setactlistData);
  const updtoken = useSelector((state) => state.updtoken);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const [isDisabled, setDisabled] = useState(false);
  const [croppedImage, setCroppedImage] = useState("");

  const [auctime, setauctime] = useState('11:10:00');
  const [defimg, setdefimg] = useState(auctiondefaultLogo);
  const atmval = '2022-04-17T' + localStorage.getItem('auction_tm');
  const [admin_id, setadminid] = useState(localStorage.getItem('admin_id'));
  const [admin_name, setadmin_name] = useState(localStorage.getItem('admin_name'));
  const [deftime, setdeftime] = useState({
    $D: 13, $H
      :
      4,
    $L
      :
      "en",
    $M
      :
      10,
    $W
      :
      1,
    $d
      :
      'Mon Nov 13 2023 04:00:00 GMT+0530 (India Standard Time) {}',
    $isDayjsObject
      :
      true,
    $m
      :
      0,
    $ms
      :
      0,
    $s
      :
      0,
    $u
      :
      undefined,
    $x
      :
      {},
    $y
      :
      2023
  });
  const loginuser = useSelector((state) => state.setUserlog);
  const history = useHistory({ forceRefresh: true });
  const [cid, setCid] = useState(loginuser["cid"]);
  const aid = localStorage.getItem("auction_id");
  let logo_pic = "";

  // const firebaseConfig = {
  //   apiKey: "AIzaSyAiZfDIylsaUIB5xfQOdlC6qKaxUxlMl3g",
  //   authDomain: "jain-cricket-league.firebaseapp.com",
  //   databaseURL: "https://jain-cricket-league.firebaseio.com",
  //   projectId: "jain-cricket-league",
  //   storageBucket: "jain-cricket-league.appspot.com",
  //   messagingSenderId: "886224719584",
  //   appId: "1:886224719584:web:be3d8efa9acf1b23cd0a85"
  // };
  // const app = initializeApp(firebaseConfig);

  const onSubmit = (values) => {

    setDisabled(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    if (document.getElementById("logo_pic") != null) {
      logo_pic = document.getElementById("logo_pic").value;
    }

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };

    values["logo_pic"] = croppedImage;
    // //  console.log(values["logo_pic"])
    values["atm"] = auctime.$H + ":" + auctime.$m + ":00";
   
    localStorage.setItem('auction_type',values.acttype)
    if (values["type"] == undefined) {

      values["type"] = "0"
    }
    DataService.editAuction(values, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // //  console.log(auctime.$H.toString())
        // Make sure you have these imports at the top of your file
// import { getDatabase, ref, set, update, push, query, limitToLast, get } from "firebase/database";

if (response.success == true) {
  toast.success(response.msg, {
    theme: "dark",
    position: "bottom-center",
  });
  
  // Store original data for comparison
  const originalItem = getpageData?.responsedata?.list?.find(ele => ele.aid == aid);
  let isOnlyLogoChanged = false;
  let isAnyOtherFieldChanged = false;
  
  if (originalItem) {
    // Check if only logo changed
    const logoChanged = response.data.logo && response.data.logo !== originalItem.logo;
    
    // Check if any other fields changed
    const otherFieldsChanged = 
      values.type !== originalItem.type ||
      values.acttype !== originalItem.acttype ||
      values.dt !== originalItem.dt ||
      values.unit !== originalItem.unit ||
      values.aname !== originalItem.aname ||
      values.totalpoint !== originalItem.totalpoint ||
      values.minbid !== originalItem.minbid ||
      values.bidup !== originalItem.bidup ||
      values.player !== originalItem.player ||
      values.minplayer !== originalItem.minplayer ||
      values.ses !== originalItem.ses;
    
    // For time comparison, format the original time properly
    const originalHours = originalItem.atm ? originalItem.atm.split(':')[0] : '00';
    const originalMinutes = originalItem.atm ? originalItem.atm.split(':')[1] : '00';
    const formattedOriginalTime = `${originalHours.padStart(2, '0')}:${originalMinutes.padStart(2, '0')}`;
    
    // Format new time
    var thatm = auctime.$H.toString()
    var tmatm = auctime.$m.toString()
    if (thatm.length > 1) {
      thatm = auctime.$H
    } else {
      thatm = '0' + auctime.$H
    }
    if (tmatm.length > 1) {
      tmatm = auctime.$m
    } else {
      tmatm = '0' + auctime.$m
    }
    const formattedNewTime = thatm + ":" + tmatm;
    
    const timeChanged = formattedNewTime !== formattedOriginalTime;
    
    isOnlyLogoChanged = logoChanged && !otherFieldsChanged && !timeChanged;
    isAnyOtherFieldChanged = otherFieldsChanged || timeChanged;
  }

  if (getpageData != 0) {
    const updateitem = getpageData.responsedata.list.filter(
      (ele, ind) => {
        if (ele.aid == aid) {
          ele.logo = response.data.logo || '';
          ele.type = values.type;
          ele.acttype = values.acttype;
          ele.dt = values.dt;
          ele.unit = values.unit;
          
          var thatm = auctime.$H.toString()
          var tmatm = auctime.$m.toString()
          if (thatm.length > 1) {
            thatm = auctime.$H
          } else {
            thatm = '0' + auctime.$H
          }
          if (tmatm.length > 1) {
            tmatm = auctime.$m
          } else {
            tmatm = '0' + auctime.$m
          }

          ele.atm = thatm + ":" + tmatm;
          ele.aname = values.aname;
          ele.totalpoint = values.totalpoint;
          ele.minbid = values.minbid;
          ele.bidup = values.bidup;
          ele.player = values.player;
          ele.minplayer = values.minplayer;
          ele.ses = values.ses;
        }
        return ele;
      }
    );

    localStorage.setItem("auction_name", values.aname);
    let responsedata = {
      responsedata: {
        path: getpageData.responsedata.path,
        cid: cid,
        list: updateitem,
      },
    };
    dispatch(actlistData(responsedata));
  }
  
  const db = getDatabase();
  set(ref(db, 'map/info/' + aid), {
    "type": "1", "upd": "2", 'id': aid, "detail": {
      "aname": values.aname,
      "acttype": values.acttype,
      "atm": values.atm,
      "logo": response.data.logo,
      "bidup": values.bidup,
      "dt": values.dt,
      "player": values.player,
      "totalpoint": values.totalpoint,
      "minbid": values.minbid,
      "minplayer": values.minplayer,
    }, "tkn": updtoken
  });
  
  // SIMPLIFIED VERSION WITHOUT QUERY (if you don't want to use query)
  // Add work5 only when ONLY logo changed
  if (values["logo_pic"] != "" && isOnlyLogoChanged) {
    var data = {};
    data['work1'] = 3;
    update(ref(db, 'map/info/datastatus/' + aid), data);
    
    var workhistory = {};
    var currentTime = new Date();
    
    workhistory['worktyp'] = 'work1';
    workhistory['id'] = admin_id;
    workhistory['name'] = admin_name;
    workhistory['timestamp'] = currentTime.toISOString();
    workhistory['aname'] = values.aname;
    workhistory['aid'] = aid;
    
    // Simple push without checking for duplicates
    push(ref(db, 'map/info/workhistory'), workhistory);
  }
  
  // Add work6 when other details changed (with or without logo)
  if (isAnyOtherFieldChanged && !isOnlyLogoChanged) {
    var data = {};
    data['work15'] = 3;
    update(ref(db, 'map/info/datastatus/' + aid), data);
    
    var workhistory = {};
    var currentTime = new Date();
    
    workhistory['worktyp'] = 'work15';
    workhistory['id'] = admin_id;
    workhistory['name'] = admin_name;
    workhistory['timestamp'] = currentTime.toISOString();
    workhistory['aname'] = values.aname;
    workhistory['aid'] = aid;
    
    // Simple push without checking for duplicates
    push(ref(db, 'map/info/workhistory'), workhistory);
  }
  
  // Keep original work10 logic for time
  if (values['atm']!='0:0:00') {
    var data = {};
    data['work10'] = 3;
    update(ref(db, 'map/info/datastatus/' + aid), data);
    var workhistory = {};
    var currentTime = new Date();
    
    workhistory['worktyp'] = 'work10';
    workhistory['id'] = admin_id;
    workhistory['name'] = admin_name;
    workhistory['timestamp'] = currentTime.toISOString();
    workhistory['aname'] = values.aname;
    workhistory['aid'] = aid;
    
    push(ref(db, 'map/info/workhistory'), workhistory);
  }
  
  history.push(BASE_PATH + 'auction-detail');
} else {
          toast.error(response.msg, {
            theme: "colored",
            position: "bottom-center",
          });
        }

        setDisabled(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", {
          theme: "colored",
          position: "bottom-center",
        });
        setDisabled(false);
      });
  };

  useEffect(() => {

    const updateitem = getpageData.responsedata?.list?.filter((ele, ind) => {
      if (ele.aid == aid) {
        console.log('ele')
        console.log(ele)

        var tm = ele.atm.split(':')
        

        //var aaa = dayjs('2014-08-18T'+ele.atm);
        setauctime(dayjs('2022-04-17T' + tm[0] + ':' + tm[1]))
        // setatmval('2022-04-17T16:20:00');
        setValue("type", ele.type);
        setValue("dt", ele.dt);
        setValue("aname", ele.aname);
        setValue("totalpoint", ele.totalpoint);
        setValue("minbid", ele.minbid);
        setValue("bidup", ele.bidup);
        setValue("player", ele.player);
        setValue("ses", ele.ses);
        setValue("unit", ele.unit);
        setValue("acttype", ele.acttype);
        setValue("minplayer", ele.minplayer > 0 ? ele.minplayer : 0);
        if (ele.logo !== "") {
          setdefimg(getpageData.responsedata.path + ele.logo)
        }
        $(".crop-default img").attr(
          "src",
          ele.logo
            ? `${getpageData.responsedata.path}${ele.logo}`
            : auctiondefaultLogo
        );
      }
    });
    $(".crop-default").click(function () {
      $("#crop-pic").click();
    });
  }, []);
  function timed(e) {

    setauctime(e)
  }

  return (
    <>
      <div>
        <Navigationtitle data={match} />
        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          <div className="row">
                            {/* <div className="col-md-12"> */}
                            <div className="col-md-12">
                              <div className="form-group text-box-margin addauc-div-margin" >
                                <div className="col-md-2">
                                  <label className="edit-label" typeof="type">Auction Logo</label>
                                  <div style={{ clear: "both" }}></div>
                                </div>
                                <div className="col-md-8">
                                {localStorage.getItem('crp_typ') == 0 ?
                                    <ImageCropper2
                                    croppedImage={croppedImage}
                                      defaultImage={defimg}
                                      setCroppedImage={setCroppedImage}
                                    /> :
                                    <ImageCropper1
                                      croppedImage={croppedImage}
                                      defaultimage={defimg}
                                      setCroppedImage={setCroppedImage}
                                    />
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin" style={{ marginBottom: "0" }}>
                                <div className="col-md-2">
                                  <label  typeof="type" className="edit-label"> Sports Type* </label>
                                </div>
                                <div className="col-md-4">
                                  <select
                                    className="form-control addform-control"
                                    type="text"
                                    {...register("acttype", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  >
                                    <option value={0}>Cricket</option>
                                    <option value={1}>Football</option>
                                    <option value={2}>Volleyball</option>
                                    <option value={3}>Tennis</option>
                                    <option value={4}>Badminton</option>
                                    <option value={5}>Kabaddi</option>
                                    <option value={6}>Pickleball</option>
                                    <option value={7}>Table Tennis</option>
                                    <option value={8}>Hockey</option>
                                    <option value={11}>Basketball</option>
                                    <option value={12}>Baseball</option>
                                  </select>
                                  {errors.acttype && (
                                    <p className="text-error">
                                      {errors.acttype.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="form-group text-box-margin  addauc-div-margin">
                                <div className="col-md-1">
                                  <label  typeof="srtkey" className="edit-label"> Season</label>
                                </div>
                                <div className="col-md-3">
                                  {" "}
                                  <select
                                    className="form-control addform-control season-control"
                                    type="text"
                                    {...register("ses", {

                                    })}
                                  >
                                    <option value="">--select--</option>
                                    {getSeason()?.map((dt, key) => {
                                      return <option value={dt}>{dt}</option>;
                                    })}
                                  </select>
                                  {/* {errors.ses && (
                                      <p className="text-error">
                                        {errors.ses.message}
                                      </p>
                                    )} */}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  <label typeof="aname"  className="edit-label"> Auction Name* </label>
                                </div>
                                <div className="col-md-8">
                                  <input
                                    className="form-control addinput-control"
                                    type="text"
                                    {...register("aname", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.aname && (
                                    <p className="text-error">
                                      {errors.aname.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  <label  typeof="dt" className="edit-label"> Auction Date* </label>
                                </div>
                                <div className="col-md-4 addauc-time-margin">

                                  {" "}
                                  <input
                                    // min={moment().format("YYYY-MM-DD")}
                                    className="form-control addinput-control"
                                    type="date"
                                    {...register("dt", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.dt && (
                                    <p className="text-error">
                                      {errors.dt.message}
                                    </p>
                                  )}

                                </div>
                                <div className="form-group text-box-margin  addauc-topmargin addauc-time-margin">

                                  <div className="col-md-3 auctime time-div">
                                    {" "}
                                    <LocalizationProvider className="timepick" dateAdapter={AdapterDayjs}>
                                      <TimePicker label="Auction Time"
                                      className="picker-time"
                                        // value={auctime}
                                        defaultValue={dayjs(atmval)}

                                        Value={auctime}
                                        format="HH:mm:ss"
                                        // className="mypicker"
                                        onChange={(e) => timed(e)}
                                        PopperProps={{
                                          popperOptions: {
                                            modifiers: {
                                              preventOverflow: { enabled: true },
                                            },
                                          },
                                        }} />
                                    </LocalizationProvider>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  <label  typeof="totalpoint" className="edit-label">
                                    {" "}
                                    Points Per Team*{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    className="form-control addinput-control"
                                    {...register("totalpoint", {
                                      required: true,
                                      required: "required field.",
                                       validate: (value) =>
        value >= 0 || "Value must not be negative."
                                    })}
                                  />
                                  {errors.totalpoint && (
                                    <p className="text-error">
                                      {errors.totalpoint.message}
                                    </p>
                                  )}
                                </div>
                                <div className="col-md-1 padding-top-16px addauc-topmargin">
                                  <label typeof="totalpoint" className="edit-label"> Units</label>
                                </div>
                                <div className="col-md-3">
                                  {" "}
                                  <input
                                    type="text"
                                    className="form-control addinput-control"
                                    placeholder="CR/LAC"
                                    {...register("unit")}
                                  />
                                  {errors.unit && (
                                    <p className="text-error">
                                      {errors.unit.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label  typeof="minbid" className="edit-label"> Base Bid* </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    className="form-control addinput-control"
                                    {...register("minbid", {
                                      required: true,
                                      required: "required field.",
                                       validate: (value) =>
        value >= 0 || "Value must not be negative."
                                    })}
                                    step="any"
                                  />
                                  {errors.minbid && (
                                    <p className="text-error">
                                      {errors.minbid.message}
                                    </p>
                                  )}
                                </div>

                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="bidup" className="edit-label">
                                    {" "}
                                    Bid Increase by*{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    className="form-control addinput-control"
                                    {...register("bidup", {
                                      required: true,
                                      required: "required field.",
                                       validate: (value) =>
        value >= 0 || "Value must not be negative."
                                    })}
                                    step="any"
                                  />
                                  {errors.bidup && (
                                    <p className="text-error">
                                      {errors.bidup.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>



                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label  typeof="player" className="edit-label">
                                    {" "}
                                    Player Per Team*{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    className="form-control addinput-control"
                                    {...register("player", {
                                      required: true,
                                      required: "required field.",
                                       validate: (value) =>
        value >= 0 || "Value must not be negative."
                                    })}
                                  />
                                  {errors.player && (
                                    <p className="text-error">
                                      {errors.player.message}
                                    </p>
                                  )}
                                </div>
                                <span className="padding-left-16px">(Max Limit)</span>
                              </div>
                            </div>
                            {/* </div> */}
                            <div className="col-md-12 margin-top-14px addauc-topmargin">
                              <div className="form-group text-box-margin addauc-div-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="player" className="edit-label" >
                                    {" "}
                                    Player Per Team{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    className="form-control addinput-control"
                                    {...register("minplayer", {
                                      required: false,
                                       validate: (value) =>
        value >= 0 || "Value must not be negative."
                                    })}
                                  />
                                  {errors.minplayer && (
                                    <p className="text-error">
                                      {errors.minplayer.message}
                                    </p>
                                  )}
                                </div>
                                <span className="padding-left-16px">(Min Limit)</span>
                              </div>
                            </div>
                            <div className="col-md-12 ">
                              <button
                                className="button addauc-button"
                                type="submit"
                                style={{
                                  backgroundColor: "#186CC2",
                                  borderRadius: "5px",
                                  marginLeft: "12px",
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Editauction;
